import { makeStyles } from '@material-ui/core';
import ArrowDown from '../../assets/svg/down-arrow-circle.svg';

interface IFloatingDownArrow {
    isDisplay: boolean;
    isStylistView: boolean;
    scrollToLatestMessage: () => void;
}

export const useStyles = makeStyles((theme) => ({
    floatingButton: {
        position: 'absolute',
        right: '15px',
        padding: '10px',
        background: '#ffffff',
        height: '30px',
        width: '30px',
        borderRadius: '30px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
    },
}));

export default function FloatingDownArrow({ isDisplay, scrollToLatestMessage, isStylistView }: IFloatingDownArrow) {
    const classes = useStyles();
    return (
        <div
            className={classes.floatingButton}
            style={{ visibility: isDisplay ? 'visible' : 'hidden', bottom: isStylistView ? '15px' : '80px' }}
            onClick={scrollToLatestMessage}
        >
            <img src={ArrowDown} alt="Down" height={30} width={30} />
        </div>
    );
}
